import { ArrowsCircleIcon } from '@grupoboticario/flora-react-icons';
import { actions } from 'core/use-cases/user';
import { useDispatch } from 'react-redux';

import Styles from './Cycle.styles';

const VdfCycleEmpty = () => {
  const dispatch = useDispatch();

  return (
    <Styles.EmptyCycle>
      <span>Não foi possível mostrar as informações do ciclo</span>
      <Styles.ReloadCycleButton onClick={() => dispatch(actions.cyclesFetch.request())}>
        <ArrowsCircleIcon size={12} />
        Recarregar
      </Styles.ReloadCycleButton>
    </Styles.EmptyCycle>
  );
};

export default VdfCycleEmpty;
